module.exports = __webpack_public_path__ + "src/code/sidenav-app/sideback.svg";